// extracted by mini-css-extract-plugin
export default {"root":"IGRl3uR0lFCEpQr79DAl"};